import { Box, Button, styled, Typography, useTheme } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { onlineIcon } from "../../../assets";
import { tokens } from "../../../theme";
import { conciseAddress } from "../../../utils/formatters";

const StyledButton = styled(Button)(({ theme, colors, selected }) => ({
  backgroundColor: selected ? colors.primary[500] : colors.whiteAccent[900],
  color: selected ? colors.whiteAccent[900] : colors.primary[500],
  fontSize: "14px",
  fontWeight: 400,
  width: "100%",
  height: "40px",
  borderRadius: "7px",
  borderColor: colors.primary[500],
  "&:hover": {
    backgroundColor: colors.primary[600],
    borderColor: colors.primary[500],
    color: colors.whiteAccent[900],
  },
  padding: 0,
}));

const CardWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "10px 7px 15px 7px",
  backgroundColor: theme.palette.secondary.dark,
  width: "280px",
  height: "317px",
  borderRadius: 14,
  boxShadow: "0px 15px 30px rgba(118, 118, 118, 0.2)",
  position: "relative",
}));

export const ScholarCard = ({
  coverPic,
  profilePic,
  name,
  address,
  id,
  totalNfts,
  split,
  earnings,
  key,
  scholarSelected,
  setScholarSelected,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  return (
    <CardWrapper key={key}>
      <img
        src={onlineIcon}
        alt={"nft"}
        style={{
          position: "absolute",
          right: 3,
          top: 3,
        }}
      />

      <img
        src={coverPic}
        alt={"nft"}
        style={{
          width: "259px",
          height: "100px",
          marginBottom: 50,
        }}
      />
      <Box
        display="flex"
        flexDirection="row"
        width="90%"
        marginBottom="5px"
        justifyContent="space-between"
        alignItems={"flex-end"}
        sx={{ position: "absolute", top: "90px" }}
      >
        <Box display="flex" alignItems={"flex-end"}>
          <img
            src={profilePic}
            alt={"nft"}
            style={{
              width: "70px",
              height: "70px",
              borderRadius: "70px",
            }}
          />
          <Box
            display="flex"
            flexDirection="column"
            mb={"5px"}
            ml={"-5px"}
            justifyContent="space-between"
            height="40px"
          >
            <Typography
              variant="fs12"
              color={colors.black[500]}
              fontWeight={500}
              pl={1}
            >
              {name.length > 10 ? conciseAddress(name) : name}
            </Typography>

            <Typography
              variant="fs10"
              color={colors.black[500]}
              fontWeight={500}
              pl={1}
            >
              {conciseAddress(address)}
            </Typography>
          </Box>
        </Box>

        <Box
          // display="flex"
          // flexDirection="row"
          width="82px"
          // marginBottom="5px"
          // alignItems={"center"}
          // justifyContent={"space-between"}
          // pl={1}
        >
          <StyledButton
            onClick={() => navigate(`/scholar-details/${id}`)}
            variant="outlined"
            colors={colors}
          >
            <Typography variant="fs10"> View More</Typography>
          </StyledButton>
        </Box>
      </Box>

      <Box
        display="flex"
        flexDirection="row"
        width={"100%"}
        justifyContent="space-between"
      >
        <Typography
          variant="fs14"
          width={"100%"}
          color={colors.black[500]}
          fontWeight={500}
          pl={1}
        >
          NFTs
        </Typography>

        <Typography
          variant="fs14"
          width={"100%"}
          color={colors.black[500]}
          fontWeight={500}
          align="right"
          pl={1}
        >
          {totalNfts}
        </Typography>
      </Box>

      <Box
        display="flex"
        flexDirection="row"
        width={"100%"}
        justifyContent="space-between"
      >
        <Typography
          variant="fs12"
          width={"100%"}
          color={colors.black[500]}
          fontWeight={500}
          pl={1}
        >
          Splits
        </Typography>

        <Typography
          variant="fs14"
          width={"100%"}
          color={colors.black[500]}
          fontWeight={500}
          align="right"
          pl={1}
        >
          {split}
        </Typography>
      </Box>

      <Box
        display="flex"
        flexDirection="row"
        width={"100%"}
        justifyContent="space-between"
      >
        <Typography
          variant="fs12"
          width={"100%"}
          color={colors.black[500]}
          fontWeight={500}
          pl={1}
        >
          Earnings
        </Typography>

        <Typography
          variant="fs14"
          width={"100%"}
          color={colors.black[500]}
          fontWeight={500}
          align="right"
          pl={1}
        >
          {earnings}
        </Typography>
      </Box>

      <Box
        display="flex"
        flexDirection="row"
        width="100%"
        marginBottom="5px"
        alignItems={"center"}
        justifyContent={"space-between"}
        pl={1}
      >
        <StyledButton
          onClick={() => {
            if (scholarSelected === address) {
              setScholarSelected("");
            } else {
              setScholarSelected(address);
            }
          }}
          variant="outlined"
          colors={colors}
          selected={scholarSelected === address}
        >
          {scholarSelected === address ? "Selected" : "Select"}
        </StyledButton>
      </Box>
    </CardWrapper>
  );
};
